import React, { useState, useEffect, useContext } from 'react';
import { formatAmount, formatRelativeDate } from '../utility/formator';
import { BodyText, HeadingText, Card, CausesIcon } from '@paypalcorp/pp-react';
import { DonorWall } from '@paypalcorp/donate-react';
import PropTypes from 'prop-types';
import {
  Context as WorldReadyContext,
  Message,
} from '@paypalcorp/worldready-react';
import { MessageFormat } from '@paypalcorp/worldready';
import { formatNumber } from '../utility/worldReadyUtils';

function formatContribution(contribution) {
  const transactionDate =
    contribution?.transaction_time ?? new Date().toISOString();

  return {
    ...contribution,
    formattedAmount: formatAmount({
      value: formatNumber(contribution.amount),
      currency: contribution.currency_code,
    }),
    formattedDate: formatRelativeDate(new Date(transactionDate)),
  };
}
function LandingDonorWall({
  totalNumberOfTransactions,
  contributionsList,
  isLoading,
  currentPage,
  handleShowMore,
  paginationLimit,
}) {
  const [donorWall, setDonorWall] = useState({ featured: [], list: [] });
  const worldReady = useContext(WorldReadyContext);

  useEffect(() => {
    setDonorWall({
      featured: contributionsList.featured.map(formatContribution),
      list: contributionsList.list.map(formatContribution),
    });
  }, [contributionsList]);

  const getDonorWallContent = (id, params) => {
    return new MessageFormat(worldReady, {
      id: `landing.campaigns.${id}`,
    }).format(params);
  };

  return (
    <>
      <DonorWall
        content={{
          title: getDonorWallContent('donorWallTitle', {
            totalDonations: formatNumber(totalNumberOfTransactions),
          }),

          loading: getDonorWallContent('loadingLabel', {}),
          showMore: getDonorWallContent('showMore', {}),
          ariaLabel: 'campaignDonations',
          anonymous: getDonorWallContent('anonymous', {}),
          first: getDonorWallContent('first', {}),
          top: getDonorWallContent('top', {}),
          paginationLimitMessage: getDonorWallContent(
            'transactionsLimitError',
            {}
          ),
        }}
        contributions={donorWall}
        totalTransactions={totalNumberOfTransactions}
        currentPage={currentPage}
        transactionsPerPage={10}
        handleShowMore={handleShowMore}
        isLoading={isLoading}
        paginationLimit={paginationLimit}
      />
      {totalNumberOfTransactions === 0 && (
        <Card className="donor-wall-card">
          <div className="icon">
            <CausesIcon size="lg" />
          </div>
          <div className="content">
            <HeadingText size="xs">
              <Message id="landing.campaigns.zeroTitle" />
            </HeadingText>
            <BodyText className="description">
              <Message id="landing.campaigns.zeroDescription" />
            </BodyText>
          </div>
        </Card>
      )}
    </>
  );
}

LandingDonorWall.propTypes = {
  totalNumberOfTransactions: PropTypes.number,
  contributionsList: PropTypes.object,
  isLoading: PropTypes.bool,
  currentPage: PropTypes.number,
  handleShowMore: PropTypes.func,
  paginationLimit: PropTypes.number,
};

export default LandingDonorWall;
